module.exports = __webpack_public_path__ + "static/media/blue-loader.175a5976.svg";